import React from 'react';
import { Hero } from './sections/Hero';
import { PainSection } from './sections/PainSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { OutcomeSection } from './sections/OutcomeSection';
import { FAQSection } from './sections/FAQSection';
import { PricingSection } from './sections/PricingSection';
import { Footer } from './Footer';
import { FloatingCTA } from './ui/FloatingCTA';
import { MidPageCTA } from './ui/MidPageCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-navy-900 text-cream-50 selection:bg-gold-400 selection:text-navy-900 overflow-x-hidden" data-id="element-35">
      <Hero data-id="element-36" />
      <PainSection data-id="element-37" />
      <ProblemSection data-id="element-38" />
      <SolutionSection data-id="element-39" />
      <FeaturesSection data-id="element-40" />
      <MidPageCTA data-id="element-41" />
      <TestimonialsSection data-id="element-42" />
      <OutcomeSection data-id="element-43" />
      <FAQSection data-id="element-44" />
      <PricingSection data-id="element-45" />
      <Footer data-id="element-46" />
      <FloatingCTA data-id="element-47" />
    </main>;
}